<template>
    <common-card class="mt-3">
        <v-row>
            <v-col>
                <v-row style="padding: 15px 20px 0px 20px">
                    <v-col cols="12" md="6">
                        <h1>Administrador Productos de Alianzas</h1>
                    </v-col>
                    <v-col cols="12" md="6" style="text-align: end">
                        <v-btn class="common-botton" dark :loading="loading" @click="
                            $router.push('/administracion/productos/crear')
                            ">
                            <v-icon class="mr-2">mdi-plus</v-icon>
                            <span>Nuevo</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <!-- Expansion Panel para Búsqueda detallada -->
        <v-expansion-panels elevation="0" style="padding: 30px; border-radius: 20px">
            <v-expansion-panel>
                <v-expansion-panel-header style="padding: 35px">
                    <h3 style="color: #42352e">Búsqueda detallada</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-autocomplete v-model="filtros.alianza" :items="alianzasOptions" item-text="nombre"
                                item-value="id" label="Alianza" outlined dense color="primary"
                                background-color="white"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="filtros.nombre" label="Nombre" outlined dense color="primary"
                                background-color="white"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="filtros.ramo"
                                :items="ramosOptions"
                                item-text="ramo"
                                item-value="id"
                                label="Ramo"
                                outlined
                                dense
                                color="primary"
                                background-color="white"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="filtros.aseguradora"
                                :items="aseguradorasOptions"
                                item-text="nombre"
                                item-value="id"
                                label="Aseguradora"
                                outlined
                                dense
                                color="primary"
                                background-color="white"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <!-- Botones alineados a la derecha -->
                    <v-row style="padding: 0px 40px 0px 40px" class="d-flex justify-end">
                        <v-col cols="12" md="2">
                            <v-btn dark block outlined color="#00a7e4" rounded @click="limpiarFiltros()">
                                Limpiar
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="2" style="text-align: end">
                            <v-btn class="common-botton" dark block :disabled="filtersIncomplete" :loading="loading"
                                @click="filtros.pagina = 1; filtrarProductos()">
                                <span>Filtrar</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div style="padding: 0px 40px 0px 40px">
            <hr />
        </div>

        <!-- Tabla de resultados -->
        <v-row>
            <v-col cols="12" class="mb-10" style="padding: 40px">
                <v-data-table ref="productosTable" style="" :headers="headers" @pagination="pagination"
                    :server-items-length="totalItems" :page.sync="filtros.pagina"
                    :items-per-page.sync="filtros.elementosPagina" :items="productos" item-key="id" class="elevation-0"
                    :loading="loading" loading-text="Cargando..."
                    no-data-text="Para ver elementos, primero realiza una búsqueda">
                    <template v-slot:top>
                        <v-row style="padding: 15px">
                            <v-col cols="8">
                                <h2>Resultados de la búsqueda</h2>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.nombreAseguradora="{ item }">
                        {{ getAseguradoraDisplayName(item) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn icon small color="#00a7e4" @click="verDetalles(item)">
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </common-card>
</template>

<script>
// import { mainAxios } from "../../../../../mainAxios";
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import { getAlianzas } from "../../../../../services/alianzas/alianzas.service";
import { getAseguradorasList } from "../../../../../services/aseguradoras/aseguradoras.service";
import { getRamoList } from "../../../../../services/ramo/ramo.service";
import { getAllProductsWithAlianza, getProductosByFiltros } from "../../../../../services/productos/product.service";

export default {
    name: "TablaProductosAlianzas",
    components: {
        CommonCard,
    },
    data() {
        return {
            headers: [
                {
                    text: "ID",
                    align: "start",
                    sortable: false,
                    value: "id",
                    width: 90,
                },
                {
                    text: "Nombre",
                    sortable: false,
                    value: "nombre",
                    width: 220,
                },
                {
                    text: "Ramo",
                    sortable: false,
                    value: "ramo",
                    width: 180,
                },
                {
                    text: "Aseguradora",
                    value: "nombreAseguradora",
                    width: 200,
                },
                {
                    text: "Vigencia",
                    value: "vigencia",
                    width: 140,
                },
                {
                    text: "Ver",
                    value: "actions",
                    sortable: false,
                    width: 100,
                },
            ],
            filtros: {
                alianza: null,
                nombre: null,
                ramo: null,
                aseguradora: null,
                pagina: 1,
                elementosPagina: 10,
            },
            loading: false,
            productos: [],
            totalItems: 0,
            ramoOptions: [],
            aseguradorasOptions: [],
            tipoOptions: [],
            alianzasOptions: [],
            rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
            roles: JSON.parse(localStorage.getItem("roles")),
            isResetting: false,
            hasMountedTable: false,
        };
    },

    computed: {
        filtersIncomplete() {
            return !this.filtros.alianza && !this.filtros.nombre && !this.filtros.ramo && !this.filtros.aseguradora;
        },
        canViewCreate() {
            let canView = false;
            let roles = [];
            this.roles.forEach((element) => {
                roles.push(element.rol);
            });
            const rolesToView = ["ADMIN", "MANAGERCC", "OPERADOR"];
            roles.forEach((element) => {
                if (rolesToView.includes(element)) {
                    canView = true;
                }
            });
            return canView;
        },
    },

    mounted() {
        this.getAlianzasOptions();
        this.getRamosOptions();
        this.getAseguradorasOptions();
        this.$nextTick(() => {
            this.hasMountedTable = true;
        });
    },

    methods: {
        async getAlianzasOptions() {
            this.alianzasOptions = await getAlianzas();
        },

        async getRamosOptions() {
            const response = await getRamoList();
            this.ramosOptions = Array.isArray(response)
                ? response
                : response?.data ?? [];
        },

        async getAseguradorasOptions() {
            const response = await getAseguradorasList();
            this.aseguradorasOptions = Array.isArray(response)
                ? response
                : response?.data ?? [];
        },

        getAseguradoraDisplayName(producto) {
            if (producto?.nombreAseguradora) {
                return producto.nombreAseguradora;
            }

            const aseguradoraId = producto?.aseguradoraId || producto?.aseguradora_id || producto?.aseguradora;
            if (!aseguradoraId) {
                return "Sin llenar";
            }

            const aseguradora = this.aseguradorasOptions.find(
                (item) => Number(item.id) === Number(aseguradoraId),
            );

            return aseguradora?.nombre || aseguradora?.name || "Sin llenar";
        },

        getStatusDisplayName(status) {
            if (status === 2 || status === "Inactivo" || status === "INACTIVO") {
                return "Inactivo";
            }

            if (status === 1 || status === "Activo" || status === "ACTIVO") {
                return "Activo";
            }

            return status || "Sin llenar";
        },

        mapProductos(productos) {
            return (Array.isArray(productos) ? productos : []).map((producto) => ({
                ...producto,
                nombreAseguradoraDisplay: this.getAseguradoraDisplayName(producto),
                statusDisplay: this.getStatusDisplayName(producto?.status),
            }));
        },

        async getProductos() {
            this.loading = true;
            try {
                const response = await getAllProductsWithAlianza();
                const products = Array.isArray(response) ? response : [];
                this.productos = this.mapProductos(products);
                this.totalItems = products.length;
            } catch (error) {
                console.error("Error al cargar productos de alianza:", error);
            } finally {
                this.loading = false;
            }
        },

        async filtrarProductos() {
            this.loading = true;
            try {
                const body = {
                    paginado: true,
                    pagina: this.filtros.pagina,
                    elementosPagina: this.filtros.elementosPagina,
                };

                if (this.filtros.alianza) {
                    body.alianza_intermx_id = [this.filtros.alianza];
                }

                if (this.filtros.nombre) {
                    body.nombre = this.filtros.nombre;
                }

                if (this.filtros.ramo) {
                    body.ramo_id = [this.filtros.ramo];
                }

                if (this.filtros.aseguradora) {
                    body.aseguradora_id = [this.filtros.aseguradora];
                }

                const response = await getProductosByFiltros(body);
                const data = response || {};
                const products = Array.isArray(data.productos)
                    ? data.productos
                    : Array.isArray(data)
                        ? data
                        : data.items ?? [];

                this.productos = this.mapProductos(products);
                this.totalItems = data.total ?? data.totalItems ?? products.length;
                this.filtros.pagina = data.pagina ?? this.filtros.pagina;
                this.filtros.elementosPagina = data.elementosPagina ?? this.filtros.elementosPagina;
            } catch (error) {
                console.error("Error al filtrar productos:", error);
            } finally {
                this.loading = false;
            }
        },

        buildQueryParams() {
            let params = "?";

            if (this.filtros.nombre) {
                params += `nombre=${this.filtros.nombre}&`;
            }


            params += `pagina=${this.filtros.pagina}&elementosPagina=${this.filtros.elementosPagina}`;

            return params;
        },

        getFilteredProductos() {
            return this.productos.filter((item) => {
                const itemAlianza =
                    item.alianza_intermx_id ?? item.alianzaId ?? item.alianza?.id ?? item.alianza;
                const itemAseguradora =
                    item.nombreAseguradora || item.aseguradora || item.aseguradoraNombre || "";
                const itemNombre = item.nombre || "";
                const itemRamo = item.ramo || item.ramoId || item.ramo_id || "";

                const matchesAlianza =
                    !this.filtros.alianza || itemAlianza === this.filtros.alianza;
                const matchesNombre =
                    !this.filtros.nombre ||
                    itemNombre.toString().toLowerCase().includes(this.filtros.nombre.toString().toLowerCase());
                const matchesRamo =
                    !this.filtros.ramo ||
                    String(itemRamo) === String(this.filtros.ramo);
                const matchesAseguradora =
                    !this.filtros.aseguradora ||
                    itemAseguradora.toString().toLowerCase().includes(this.filtros.aseguradora.toString().toLowerCase());

                return matchesAlianza && matchesNombre && matchesRamo && matchesAseguradora;
            });
        },

        getStatusColor(status) {
            const statusColors = {
                Activo: "green",
                Inactivo: "amber darken-2",
                Baja: "red",
            };

            return statusColors[status] || "grey";
        },


        verDetalles(item) {
            this.$router.push(`/administracion/productos/visualizar/${item.id}`);
        },

        pagination(event) {
            if (!event || this.isResetting || !this.hasMountedTable) return;
            this.filtros.pagina = event.page || this.filtros.pagina;
            this.filtros.elementosPagina = event.itemsPerPage || this.filtros.elementosPagina;
            this.filtrarProductos();
        },

        limpiarFiltros() {
            this.isResetting = true;
            this.productos = [];
            this.totalItems = 0;
            this.filtros = {
                alianza: null,
                nombre: null,
                ramo: null,
                aseguradora: null,
                pagina: 1,
                elementosPagina: 10,
            };
            this.loading = false;
            this.$nextTick(() => {
                this.isResetting = false;
            });
        },

        downloadReport() {

        },
    },
};
</script>

<style scoped>
.theme--light.v-data-table {
    background-color: #f2fafc;
    color: rgba(0, 0, 0, 0.87);
    border-radius: 20px;
}

.v-expansion-panel {
    border-radius: 20px;
}

.v-expansion-panels {
    z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active {
    border-radius: 20px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
    background-color: #f6f5f9;
    color: rgba(0, 0, 0, 0.87);
}

.common-botton {
    background-color: #00a7e4 !important;
}
</style>
